import Creator from "./Creator";

export interface ColorPickerOptions {
    picker: JQuery;
    palette: JQuery;
    name: string;
    defaultcolor: number;

    onChange: (id: number) => void;
}

export default class ColorPicker {
    private options: ColorPickerOptions;

    private $picker: any;
    private $palette: any;

    private $input: JQuery;
    private $color: any;
    private $label: any;

    private $colors: any;

    public constructor(options: ColorPickerOptions) {
        this.options = options;

        this.initHtml();
    }

    private initHtml(): void {
        let This = this;

        this.$picker = this.options.picker;
        this.$palette = this.options.palette;

        this.$input = $('input[name="' + this.options.name + '"]');
        this.$color = this.$picker.find('.color');
        this.$label = this.$picker.find('.label');

        this.$colors = this.$palette.find('span');

        this.$colors.click(function (e) {
            var $this=$(this);

            var id=$this.data('id');

            This.setColor(id);
        });

        this.setColor(this.$input.val());
    }

    public setColor(id: number): void {
        var old = this.$input.val();
        var $span = this.$colors.filter('[data-id="' + id + '"]');

        this.$color.css({
            'background-color': $span.data('color')
        });

        this.$label.text($span.prop('title'));
        this.$input.val(id);

        if (old != null && old != id) {
            if (this.options.onChange) {
                this.options.onChange(id);
            }
        }
    }

    public reset(): void {
        this.setColor(this.options.defaultcolor);
    }
}